/**
 * Converts markdown text to HTML
 * Handles basic markdown features:
 * - Line breaks
 * - Bold text
 * - Italic text
 * - Links
 * - Bullet points
 * - Code blocks
 */
export function formatMarkdown(text: string): string {
  if (!text) return '';
  
  // Replace line breaks
  let formatted = text.replace(/\n/g, '<br/>');
  
  // Replace bold text: **text** or __text__
  formatted = formatted.replace(/(\*\*|__)(.*?)\1/g, '<strong>$2</strong>');
  
  // Replace italic text: *text* or _text_
  formatted = formatted.replace(/(\*|_)(.*?)\1/g, '<em>$2</em>');
  
  // Replace links: [text](url)
  formatted = formatted.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  
  // Replace bullet points
  formatted = formatted.replace(/^\s*[-*+]\s+(.*?)$/gm, '<li>$1</li>');
  formatted = formatted.replace(/<li>(.*?)<\/li>(\s*<li>)/g, '<li>$1</li><ul>$2');
  formatted = formatted.replace(/(<\/li>)(?!\s*<li>)/g, '$1</ul>');
  
  // Replace code blocks: ```code```
  formatted = formatted.replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>');
  
  // Replace inline code: `code`
  formatted = formatted.replace(/`([^`]+)`/g, '<code>$1</code>');
  
  return formatted;
}
